import { Component, Inject, OnInit } from '@angular/core';
import { MobileComponent } from 'src/app/shared/components/mobile/interface/mobile.component';
import { ApiSearchUtilService } from 'src/app/shared/service/api-search-util/api-search-util.service';
import { SubSink } from "subsink";
import { DialogService } from 'src/app/shared/components/dialog/service/dialog.service';
import { StorageService } from 'src/app/shared/service/storage/storage.service';
import { HeadingWidgetComponent } from 'src/app/shared/components/heading-widget/heading-widget.component';
import { MaterialModule } from 'src/app/shared/module/material.module';
import { I18nPipe } from 'src/app/shared/i18n/pipe/i18n.pipe';
import { ReadMoreComponent } from 'src/app/shared/components/read-more/read-more.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'ald-welcome-alert',
  templateUrl: './welcome-alert.component.html',
  styleUrls: ['./welcome-alert.component.scss'],
  standalone: true,
  imports: [
    HeadingWidgetComponent,
    MaterialModule,
    I18nPipe,
    ReadMoreComponent
  ]
})
export class WelcomeAlertComponent extends MobileComponent implements OnInit  {

  welcomeAlertText: string;
  basePath = window.location.hostname;
  isCaptive = 
    this.apiSearchUtilService.findTerm(this.basePath, "smart") ||
    this.apiSearchUtilService.findTerm(this.basePath, "ford") ||
    this.apiSearchUtilService.findTerm(this.basePath, "honda") ||
    this.apiSearchUtilService.findTerm(this.basePath, "suzuki") ||
    this.apiSearchUtilService.findTerm(this.basePath, "landrover") ||
    this.apiSearchUtilService.findTerm(this.basePath, "jaguar");

  private subs: SubSink = new SubSink();

  constructor(
    public dialogRef: MatDialogRef<WelcomeAlertComponent>,
    private apiSearchUtil:ApiSearchUtilService,
    private dialog: DialogService,
    private storageSrv: StorageService,
    private apiSearchUtilService: ApiSearchUtilService,
    
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super()
   }

  ngOnInit(): void {
  }

  getWelcomeAlertText() {
    this.welcomeAlertText = `Se sei un driver potresti ancora non visualizzare i tuoi veicoli.
    <br>
    Riprova tra qualche ora, stiamo procedendo per l'inserimento dei tuoi dati.
    <br>
    Ci scusiamo per il disagio.`
    return this.welcomeAlertText;
  }

  onSubmit() {
    this.dialogRef.close();
  }

}
